/** Printed in the proposal's Notes section whenever the estimate has Permit
 *  switched on. Rendered from the flag, never stored in the typed Notes text,
 *  so turning Permit off removes it and it can't be duplicated or edited away. */
export const PERMIT_START_NOTE =
  "Start date is dependent on the issuance of permits.";
